import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { Building2 } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const VerbaendeCaseStudyHero = () => {
  const { t, localizePath } = useLanguage();
  const p = "caseStudyVerbaende.hero";
  return (
    <section className="relative pt-36 md:pt-48 pb-16 md:pb-24 overflow-hidden bg-gradient-to-b from-primary/5 to-background">
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-chathero-mint/5 rounded-full blur-3xl" />
      <div className="container mx-auto px-4 relative z-10">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem><BreadcrumbLink asChild><Link to={localizePath("/")} className="text-muted-foreground hover:text-primary">{t(`${p}.home`)}</Link></BreadcrumbLink></BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem><span className="text-muted-foreground">{t(`${p}.caseStudies`)}</span></BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem><BreadcrumbPage className="text-chathero-mint font-medium">{t(`${p}.breadcrumbCurrent`)}</BreadcrumbPage></BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8"><div className="h-16 md:h-20 mx-auto flex items-center justify-center"><div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary/10 flex items-center justify-center"><Building2 className="w-8 h-8 md:w-10 md:h-10 text-primary" /></div></div></div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-primary leading-tight mb-6 animate-fade-in">{t(`${p}.title`)}</h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: "0.1s" }}>{t(`${p}.description`)}</p>
        </div>
      </div>
    </section>
  );
};
export default VerbaendeCaseStudyHero;
